import React from 'react';

// Strek-ikoner (24x24) fra designet «Nytt oppdrag».
const PATHS = {
  check: <path d="M5 12.5 10 17l9-10" />,
  x: <><path d="M6 6l12 12" /><path d="M18 6l-12 12" /></>,
  plus: <><path d="M12 5v14" /><path d="M5 12h14" /></>,
  pin: <><path d="M12 21s-7-7.5-7-12a7 7 0 0 1 14 0c0 4.5-7 12-7 12Z" /><circle cx="12" cy="9" r="2.5" /></>,
  truck: <><path d="M3 17V7h11v10" /><path d="M14 10h4l3 3v4h-7" /><circle cx="7" cy="18" r="2" /><circle cx="17" cy="18" r="2" /></>,
  clock: <><circle cx="12" cy="12" r="9" /><path d="M12 7v5l3 2" /></>,
  calendar: <><rect x="3" y="5" width="18" height="16" rx="2" /><path d="M3 9h18" /><path d="M8 3v4" /><path d="M16 3v4" /></>,
  card: <><rect x="2" y="6" width="20" height="12" rx="2" /><path d="M2 10h20" /></>,
  layers: <><path d="m12 3 9 5-9 5-9-5 9-5Z" /><path d="m3 13 9 5 9-5" /><path d="m3 18 9 5 9-5" /></>,
  pile: <path d="M2 20h20l-6-10-4 6-2-3-8 7Z" />,
  arrowLeft: <><path d="M19 12H5" /><path d="m11 6-6 6 6 6" /></>,
  chevronDown: <path d="m6 9 6 6 6-6" />,
};

export default function NewOrderIcon({ name, size = 20, strokeWidth = 1.8 }) {
  return (
    <svg
      width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor"
      strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"
      style={{ flexShrink: 0 }}
    >
      {PATHS[name] || null}
    </svg>
  );
}
